import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    createDirectPlanDeveloppementDemandeRequest,
    fetchPlanDeveloppementFormationsRequest,
    fetchPlanDeveloppementStepRequest,
} from "../../../../redux/actions/performanceActions";
import PlanDeveloppementCard from "../../components/PlanDeveloppementCard";
import DemandeFormModal from "../../../Formation/ResponsableFormation/RessourcesJs/demandes/DemandeFormModal";
import {
    buildFormationCardFromCampaign,
} from "../../components/planDeveloppementCardUtils";
import { asArray, StepState } from "../../Collaborateur/performanceUi";
import "../../Collaborateur/steps/PlanDeveloppementStep.css";

export default function PlanDeveloppementManagerStep({ progressId }) {
    const dispatch = useDispatch();
    const slice = useSelector((state) => state.performance.planDeveloppement);
    const data = slice.stepByProgressId[String(progressId)];
    const loading = slice.loadingByProgressId[String(progressId)];
    const error = slice.errorByProgressId[String(progressId)];
    const hasFormationCampaign = data?.formationCampaignAssociated !== false;
    const formationsSlice = useSelector((state) => state.performance.planDeveloppementFormations);
    const formations = asArray(formationsSlice.dataByProgressId[String(progressId)]);
    const formationsLoading = formationsSlice.loadingByProgressId[String(progressId)];
    const formationsError = formationsSlice.errorByProgressId[String(progressId)];
    const [selectedFormation, setSelectedFormation] = useState(null);
    const [requestModalOpen, setRequestModalOpen] = useState(false);

    useEffect(() => {
        dispatch(fetchPlanDeveloppementStepRequest(progressId));
        dispatch(fetchPlanDeveloppementFormationsRequest(progressId));
    }, [dispatch, progressId]);

    const formationCards = useMemo(() => formations.map(buildFormationCardFromCampaign), [formations]);

    const handleOpenDemande = (formation) => {
        setSelectedFormation(formation);
        setRequestModalOpen(true);
    };
    const handleSubmitDemande = (payload) => dispatch(createDirectPlanDeveloppementDemandeRequest(progressId, selectedFormation.formationId, payload));
    const requestedFormation = formations.find((formation) => formation.id === selectedFormation?.formationId);
    useEffect(() => {
        if (requestModalOpen && requestedFormation?.alreadyRequested) {
            setRequestModalOpen(false);
            setSelectedFormation(null);
        }
    }, [requestModalOpen, requestedFormation]);

    return (
        <StepState loading={loading} error={error} empty={!data}>
            {!hasFormationCampaign ? (
                <div className="plan-container">
                    <h3 className="plan-section">Plan de developpement</h3>
                    <div className="perf-state">
                        Aucune campagne Formation n'est associee a cette campagne Performance.
                    </div>
                </div>
            ) : (
                <>
                    <h3 className="perf-section-title">Formations disponibles</h3>
                    {formationsLoading && <div className="perf-state">Chargement des formations...</div>}
                    {formationsError && <div className="perf-state perf-state--warning">{formationsError}</div>}
                    {!formationsLoading && !formationsError && formationCards.length === 0 && <div className="perf-state">Aucune formation disponible pour la campagne Formation associee.</div>}
                    <div className="plan-manager-grid">
                        {formationCards.map((card) => (
                            <PlanDeveloppementCard key={card.id} item={card} onDemander={handleOpenDemande} variant="manager" />
                        ))}
                    </div>
                </>
            )}

            <DemandeFormModal
                open={requestModalOpen}
                onClose={() => setRequestModalOpen(false)}
                onSubmit={handleSubmitDemande}
                formation={selectedFormation}
                campagneId={selectedFormation?.formationCampaignId}
                type="FORMATION"
                loading={formationsLoading}
                requireCampagneSelection={false}
            />

        </StepState>
    );
}
